import { components } from 'react-select'
import ReactSelect from './ReactSelect'

export { components }
export default ReactSelect
